import { FeApi } from '@/api/fe-api';
import type { MetricsGroup } from '@/warranty-v3/entities/metric';

import { metricMapper } from './metric-mapper';

export function metricsGroupMapper(data: FeApi.MetricsGroup): MetricsGroup {
  return {
    id: data.id,
    name: data.name,
    order: data.order,
    metrics: data.metrics.map(metricMapper),
    capedLD: data.caped_ld ?? undefined,
  };
}
